import _ from '@lodash';
import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class KerdesTableDto extends IdentifiableDto {
	constructor() {
		super();
		
		/** @type {string} */
		this.csorszam = null;
		/** @type {string} */
		this.leiras = null;
		/** @type {string} */
		this.leirasPlaintext = null;
		/** @type {string} */
		this.magyarazat = null;
		/** @type {string} */
		this.magyarazatPlaintext = null;
		/** @type {number} */
		this.feladatTipusId = null;
		/** @type {number} */
		this.aktiv = null;
		/** @type {number} */
		this.reviewCount = null;
	}

	/**
	 * @typedef {Object} _KerdesTableDtoProps
	 * @property {string} csorszam
	 * @property {string} leiras
	 * @property {string} leirasPlaintext
	 * @property {string} magyarazat
	 * @property {string} magyarazatPlaintext
	 * @property {number} feladatTipusId
	 * @property {number} aktiv
	 * @property {number} reviewCount
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _KerdesTableDtoProps} KerdesTableDtoProps
	 */
	/**
	 *
	 * @param {KerdesTableDtoProps} props
	 * @returns {KerdesTableDto}
	 */
	setup(props) {
		super.setup(props);

		this.csorszam = props.csorszam;
		this.leiras = props.leiras;
		this.leirasPlaintext = props.leirasPlaintext;
		this.magyarazat = props.magyarazat;
		this.magyarazatPlaintext = props.magyarazatPlaintext;
		this.feladatTipusId = props.feladatTipusId;
		this.aktiv = props.aktiv;
		this.reviewCount = props.reviewCount;

		return this;
	}

	/**
	 *
	 * @param {string} key
	 * @returns {string}
	 */
	getAsString(key) {
		if (key === 'aktiv') {
			return !_.isUndefined(this.aktiv) && this.aktiv !== null ? (this.aktiv === 1 ? 'Aktív' : 'Inaktív') : '';
		}
		return super.getAsString(key);
	}
}

export default KerdesTableDto;
